<template>
    <div class="container">
        <section v-if="operationList.length" class="section">
            <div class="u-mb-3" style="">
                <div class="u-mb-3 u-pb-0-5"></div>
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center flex-gap-16">
                    <div class="d-flex flex-gap-8 align-items-center u-mt-0-5">
                        <div class="h2 font-weight--bold u-mb-0 line-height--h3">Activity</div>
                        <div class="d-flex align-items-center flex-gap-8 flex-grow-1">
                            <div class="d-lg-none text--right w-100">
                                <button class="btn btn--tertiary-icon-before px-0" type="button" data-loading="false"
                                        aria-expanded="false">
                                    <div class="d-flex flex-row justify-content-center align-items-center  flex-gap-12">
                                        <div>
                                            <svg viewBox="0 0 24 24" class="icon">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M18 6C16.8954 6 16 6.89543 16 8C16 9.10457 16.8954 10 18 10C19.1046 10 20 9.10457 20 8C20 6.89543 19.1046 6 18 6ZM14.126 7C14.5701 5.27477 16.1362 4 18 4C20.2091 4 22 5.79086 22 8C22 10.2091 20.2091 12 18 12C16.1362 12 14.5701 10.7252 14.126 9L3 9C2.44772 9 2 8.55228 2 8C2 7.44772 2.44772 7 3 7L14.126 7ZM6 14C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14ZM2 16C2 13.7909 3.79086 12 6 12C7.86384 12 9.42994 13.2748 9.87398 15L21 15C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17L9.87398 17C9.42994 18.7252 7.86384 20 6 20C3.79086 20 2 18.2091 2 16Z"></path>
                                            </svg>
                                        </div>
                                        <div><span>Filter</span></div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-gap-8 flex-grow-1 justify-content-start justify-content-lg-end">
                        <div class="d-flex flex-column flex-sm-row flex-gap-8 w-100 w-lg-75">
                            <div class="flex-basis-third">
                                <div class="select-custom">
                                    <div class="css-b62m3t-container"><span id="react-select-2-live-region"
                                                                            class="css-7pg0cj-a11yText"></span><span
                                            aria-live="polite" aria-atomic="false" aria-relevant="additions text"
                                            role="log" class="css-7pg0cj-a11yText"></span>
                                        <div class="css-5uxsgg-control">
                                            <div class="css-1hgjyuw">
                                                <div class="css-kr88vm-singleValue">Transaction ID</div>
                                                <div class="css-ddyyn" data-value=""><input class=""
                                                                                            autocapitalize="none"
                                                                                            autocomplete="off"
                                                                                            autocorrect="off"
                                                                                            id="react-select-2-input"
                                                                                            spellcheck="false"
                                                                                            tabindex="0" type="text"
                                                                                            aria-autocomplete="list"
                                                                                            aria-expanded="false"
                                                                                            aria-haspopup="true"
                                                                                            role="combobox"
                                                                                            aria-activedescendant=""
                                                                                            value=""
                                                                                            style="color: inherit; background: 0px center; opacity: 1; width: 100%; grid-area: 1 / 2; font: inherit; min-width: 2px; border: 0px; margin: 0px; outline: 0px; padding: 0px;">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <svg viewBox="0 0 24 24"
                                                     class="icon icon--24 mr-4 select-custom__dropdown-icon select-custom__dropdown-icon--active">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <div class="form-control">
                                    <div class="text--sm form-control__input-label-container"></div>
                                    <div class="form-control__input-container form-control__input-container--empty">
                                        <div class="mr-3 form-control__input-addon">
                                            <svg viewBox="0 0 24 24" class="icon icon--18 text--gray-4">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8487 17.3729 13.5509 16.3199 14.9056L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9057 16.3198C13.551 17.3729 11.8487 18 10 18C5.58172 18 2 14.4183 2 10Z"></path>
                                            </svg>
                                        </div>
                                        <input maxlength="255" type="text" id="search" class="form-control__input"
                                               placeholder="Text to search..." name="" value="">
                                        <div class="ml-3 form-control__input-addon">
                                            <button class="btn btn--primary btn--small" type="button"
                                                    data-loading="false" aria-expanded="false">Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-none d-lg-flex">
                                <button class="btn btn--tertiary-icon-before px-0" type="button" data-loading="false"
                                        aria-expanded="false">
                                    <div class="d-flex flex-row justify-content-center align-items-center  flex-gap-12">
                                        <div>
                                            <svg viewBox="0 0 24 24" class="icon">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M18 6C16.8954 6 16 6.89543 16 8C16 9.10457 16.8954 10 18 10C19.1046 10 20 9.10457 20 8C20 6.89543 19.1046 6 18 6ZM14.126 7C14.5701 5.27477 16.1362 4 18 4C20.2091 4 22 5.79086 22 8C22 10.2091 20.2091 12 18 12C16.1362 12 14.5701 10.7252 14.126 9L3 9C2.44772 9 2 8.55228 2 8C2 7.44772 2.44772 7 3 7L14.126 7ZM6 14C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14ZM2 16C2 13.7909 3.79086 12 6 12C7.86384 12 9.42994 13.2748 9.87398 15L21 15C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17L9.87398 17C9.42994 18.7252 7.86384 20 6 20C3.79086 20 2 18.2091 2 16Z"></path>
                                            </svg>
                                        </div>
                                        <div><span>Filter</span></div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <table class="table-v2 activity-table-v2 activity-table-v2--plain">
                <thead>
                <tr>
                    <th>
                        <div class="table-v2__cell"><span>Transaction</span></div>
                    </th>
                    <th>
                        <div class="table-v2__cell"><span>Amount</span></div>
                    </th>
                    <th>
                        <div class="table-v2__cell"><span>Balance</span></div>
                    </th>
                    <th>
                        <div class="table-v2__cell"><span>Peer</span></div>
                    </th>
                    <th>
                        <div class="table-v2__cell"><span>Date</span></div>
                    </th>
                    <th>
                        <div class="table-v2__cell"><span>Status</span></div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr @click="goToDetail(item.transaction_id)" v-for="item in operationList" :key="item.id"
                    class="activity-table-v2__row activity-table-v2__row--clickable"
                    data-testid="list-item-activity-activity">
                    <td>
                        <div class="table-v2__cell">
                            <div class="d-flex flex-row justify-content-start align-items-top w-100">
                                <div class="flex-shrink-0 mt-1 u-mr-1">
                                    <img
                                            src="https://kanto-us-west-2-private-file-manager-shaymin.s3.us-west-2.amazonaws.com/shaymin/19d3de7d-ce68-4f56-ac05-758051731c07/19d3de7d-ce68-4f56-ac05-758051731c07-logo.png?AWSAccessKeyId=AKIATHBKT3IB7TVP6UNA&amp;Expires=1790764798&amp;Signature=Q5bpRbpZSpAKdxNlBJv810bze9w%3D"
                                            alt="US Virtual Account logo" class="icon icon--32 rounded-circle">
                                </div>
                                <div class="d-flex flex-column">
                                    <div>Virtual account deposit</div>
                                    <div class="font-weight--bold overflow-wrap-anywhere">US Virtual Account</div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="table-v2__cell">
                            <div class="d-flex flex-row align-items-center w-100">
                                <div class="u-mr-1">
                                    <svg viewBox="0 0 24 24"
                                         class="icon icon--16 activity-table-v2__amount-icon activity-table-v2__amount-icon--hidden">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z"></path>
                                    </svg>
                                </div>
                                <div class="flex-basis-even d-flex flex-column">
                                    <div class="font-weight--bold w-100" style="color: transparent;"></div>
                                    <div class="w-100" style="font-size: 14px; line-height: 21px;">
                                        ${{ item.amount ?
                                        (Math.floor(item.amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ','
                                        + Number(item.amount).toFixed(2).split('.')[1]) : '0,00' }} USD
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="table-v2__cell"></div>
                    </td>
                    <td>
                        <div class="table-v2__cell">
                            <div class="d-flex flex-row w-100">
                                <div class="u-mr-1 d-none">
                                    <div class="user-thumb user-thumb--xs text--success">
                                        <img class="user-thumb__img"
                                             src="null"
                                             alt="peer avatar">
                                    </div>
                                </div>
                                <div class="d-flex flex-column u-ml-5">
                                    <div class="font-weight--bold overflow-wrap-anywhere">{{item.depositor_name}}</div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="table-v2__cell"><span>{{ item.updated_at | formatDate }}</span></div>
                    </td>
                    <td>
                        <div class="table-v2__cell">
                            <span v-if="parseInt(item.status) === 1" class="status-bubble status-bubble--completed">Completed</span>
                            <span v-else-if="parseInt(item.status) === 2" class="status-bubble status-bubble--canceled">Canceled</span>
                            <span v-else-if="parseInt(item.status) === 4" class="status-bubble status-bubble--processing">Processing</span>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="mt-5 my-3">
                <div class="col-12 d-flex flex-column flex-gap-16 flex-sm-row justify-content-start align-items-center align-items-sm-end">
                    <div><p class="mt-2 text--sm font-weight--bold text--uppercase">Download statements</p>
                        <div class="select-custom">
                            <div class="css-3iigni-container"><span id="react-select-3-live-region"
                                                                    class="css-7pg0cj-a11yText"></span><span
                                    aria-live="polite" aria-atomic="false" aria-relevant="additions text" role="log"
                                    class="css-7pg0cj-a11yText"></span>
                                <div class="css-2k6duv-control" aria-disabled="true">
                                    <div class="css-1hgjyuw">
                                        <div class="css-1gbayfg-placeholder" id="react-select-3-placeholder">Select
                                            month...
                                        </div>
                                        <div class="css-l13qfy" data-value=""><input class="" disabled=""
                                                                                     autocapitalize="none"
                                                                                     autocomplete="off"
                                                                                     autocorrect="off"
                                                                                     id="react-select-3-input"
                                                                                     spellcheck="false" tabindex="0"
                                                                                     type="text"
                                                                                     aria-autocomplete="list"
                                                                                     aria-expanded="false"
                                                                                     aria-haspopup="true"
                                                                                     role="combobox"
                                                                                     aria-activedescendant=""
                                                                                     aria-describedby="react-select-3-placeholder"
                                                                                     value=""
                                                                                     style="color: inherit; background: 0px center; opacity: 1; width: 100%; grid-area: 1 / 2; font: inherit; min-width: 2px; border: 0px; margin: 0px; outline: 0px; padding: 0px;">
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <svg viewBox="0 0 24 24"
                                             class="icon icon--24 mr-4 select-custom__dropdown-icon select-custom__dropdown-icon--disabled">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2">
                        <button class="btn btn--secondary" type="button" data-loading="false" aria-expanded="false">CSV
                            Download of Activity
                        </button>
                        <a download="activity-history.csv" class="d-none" target="_self"
                           href="blob:https://app.airtm.com/f4602479-704b-4a63-8ea0-1c8731139118"></a></div>
                </div>
            </div>
            <div class="section__content" style=""><p class="pt-3 text--center"><span>If you have questions regarding your transaction history, please contact support (</span><a
                    href="mailto:support@airtm.com?subject=CSV Transaction History"><span>support@airtm.com</span></a><span>).</span>
            </p></div>
        </section>


        <section v-else class="section">
            <div class="u-mb-3">
                <div class="u-mb-3 u-pb-0-5"></div>
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center flex-gap-16">
                    <div class="d-flex flex-gap-8 align-items-center u-mt-0-5">
                        <div class="h2 font-weight--bold u-mb-0 line-height--h3">Activity</div>
                        <div class="d-flex align-items-center flex-gap-8 flex-grow-1">
                            <div class="d-lg-none text--right w-100">
                                <button class="btn btn--tertiary-icon-before px-0" type="button"
                                        data-loading="false" aria-expanded="false">
                                    <div class="d-flex flex-row justify-content-center align-items-center  flex-gap-12">
                                        <div>
                                            <svg viewBox="0 0 24 24" class="icon">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M18 6C16.8954 6 16 6.89543 16 8C16 9.10457 16.8954 10 18 10C19.1046 10 20 9.10457 20 8C20 6.89543 19.1046 6 18 6ZM14.126 7C14.5701 5.27477 16.1362 4 18 4C20.2091 4 22 5.79086 22 8C22 10.2091 20.2091 12 18 12C16.1362 12 14.5701 10.7252 14.126 9L3 9C2.44772 9 2 8.55228 2 8C2 7.44772 2.44772 7 3 7L14.126 7ZM6 14C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14ZM2 16C2 13.7909 3.79086 12 6 12C7.86384 12 9.42994 13.2748 9.87398 15L21 15C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17L9.87398 17C9.42994 18.7252 7.86384 20 6 20C3.79086 20 2 18.2091 2 16Z"></path>
                                            </svg>
                                        </div>
                                        <div><span>Filter</span></div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-gap-8 flex-grow-1 justify-content-start justify-content-lg-end">
                        <div class="d-flex flex-column flex-sm-row flex-gap-8 w-100 w-lg-75">
                            <div class="flex-basis-third">
                                <div class="select-custom">
                                    <div class="css-b62m3t-container"><span
                                            class="css-7pg0cj-a11yText"></span><span
                                            aria-live="polite" aria-atomic="false"
                                            aria-relevant="additions text" role="log"
                                            class="css-7pg0cj-a11yText"></span>
                                        <div class="css-5uxsgg-control">
                                            <div class="css-1hgjyuw">
                                                <div class="css-kr88vm-singleValue">Transaction ID</div>
                                                <div class="css-ddyyn" data-value=""><input class=""
                                                                                            autocapitalize="none"
                                                                                            autocomplete="off"
                                                                                            autocorrect="off"
                                                                                            id="react-select-3-input"
                                                                                            spellcheck="false"
                                                                                            tabindex="0"
                                                                                            type="text"
                                                                                            aria-autocomplete="list"
                                                                                            aria-expanded="false"
                                                                                            aria-haspopup="true"
                                                                                            role="combobox"
                                                                                            aria-activedescendant=""
                                                                                            value=""
                                                                                            style="color: inherit; background: 0px center; opacity: 1; width: 100%; grid-area: 1 / 2; font: inherit; min-width: 2px; border: 0px; margin: 0px; outline: 0px; padding: 0px;">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <svg viewBox="0 0 24 24"
                                                     class="icon icon--24 mr-4 select-custom__dropdown-icon select-custom__dropdown-icon--active">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <div class="form-control">
                                    <div class="text--sm form-control__input-label-container"></div>
                                    <div class="form-control__input-container form-control__input-container--empty">
                                        <div class="mr-3 form-control__input-addon">
                                            <svg viewBox="0 0 24 24" class="icon icon--18 text--gray-4">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8487 17.3729 13.5509 16.3199 14.9056L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9057 16.3198C13.551 17.3729 11.8487 18 10 18C5.58172 18 2 14.4183 2 10Z"></path>
                                            </svg>
                                        </div>
                                        <input maxlength="255" type="text" id="search"
                                               class="form-control__input" placeholder="Text to search..."
                                               name="" value="">
                                        <div class="ml-3 form-control__input-addon">
                                            <button class="btn btn--primary btn--small" type="button"
                                                    data-loading="false" aria-expanded="false">Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-none d-lg-flex">
                                <button class="btn btn--tertiary-icon-before px-0" type="button"
                                        data-loading="false" aria-expanded="false">
                                    <div class="d-flex flex-row justify-content-center align-items-center  flex-gap-12">
                                        <div>
                                            <svg viewBox="0 0 24 24" class="icon">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M18 6C16.8954 6 16 6.89543 16 8C16 9.10457 16.8954 10 18 10C19.1046 10 20 9.10457 20 8C20 6.89543 19.1046 6 18 6ZM14.126 7C14.5701 5.27477 16.1362 4 18 4C20.2091 4 22 5.79086 22 8C22 10.2091 20.2091 12 18 12C16.1362 12 14.5701 10.7252 14.126 9L3 9C2.44772 9 2 8.55228 2 8C2 7.44772 2.44772 7 3 7L14.126 7ZM6 14C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14ZM2 16C2 13.7909 3.79086 12 6 12C7.86384 12 9.42994 13.2748 9.87398 15L21 15C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17L9.87398 17C9.42994 18.7252 7.86384 20 6 20C3.79086 20 2 18.2091 2 16Z"></path>
                                            </svg>
                                        </div>
                                        <div><span>Filter</span></div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="empty-section">
                <div class="empty-section__image">
                    <img src="@/assets/img/empty-section.svg" alt="empty"></div>
                <p class="text--black">You don't have any completed transactions.</p></div>
            <div class="section__content"><p class="pt-3 text--center"><span>If you have questions regarding your transaction history, please contact support (</span><a
                    href="mailto:support@airtm.com?subject=CSV Transaction History"><span>support@airtm.com</span></a><span>).</span>
            </p></div>
        </section>
    </div>
</template>

<script>
    import Fetch from '../../utils/fetch';
    import Api from "../../interface/index";

    export default {
        name: "activity",
        data() {
            return {
                lang: this.$i18n.locale || "en_us",
                data: {},
                operationList: [],
            }
        },
        created() {

        },
        mounted() {
            this.getOperations();
        },
        methods: {
            getOperations() {
                Fetch("/user/operations").then((r) => {
                    let data = r.data;
                    this.operationList = data.list;
                });
            },
            goToDetail(id) {
                this.$router.push(`/operations/${id}`)
            },
        },
    }
</script>

<style lang="less" scoped>
    .back_left {
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAmUlEQVRIS7XVgQmAIBCF4d8VgpZoiKAl2qwlWiJoiJYImiEEA5G0u0sd4PM83nmORsf9cAdgAaY3wwp7dA3gCFwpboFjdAaOGhWLUH+RpmIxqoFVqBRWoxLYhH7BZrQE98AWYpSNVGm4cqnogL0F7M0mrXheacYlA2LCJbCpLVJYjWtgFa6FxbgFTnG/Qc4aH30cxeqr6XNV3snLJhc9gOxwAAAAAElFTkSuQmCC) no-repeat center center;
    }

    .red_top_bg {
        position: fixed;
        top: 0;
        z-index: 10;
    }

    .basic_wrap {
        position: relative;
    }

    .big_tit {
        color: #000000;
    }

    .item_wrap {
        width: 100%;
        padding: 44px 0 0 0;

        .item {
            width: 96%;
            background: #FFFFFF;
            margin: 10px 0 10px 2%;
            border-radius: 5px;

            img {
                width: 100%;
                border-radius: 5px 5px 0 0;
            }

            p:nth-child(2) {
                padding: 10px 0 10px 10px;
                font-weight: bold;
            }

            p:nth-child(3) {
                padding: 0px 0 10px 10px;
                color: #999;
            }
        }
    }
</style>
